import React from "react";

export const Contact = () => {
  return (
    <section class="content__page content__contact">
      {/* <!-- contenido de blog --> */}
      <header class="contact__header">
        <h1 class="contact__title">Contacto</h1>
      </header>
      <div class="contact__container">
        <section class="contact__info">
          <div class="contact__data">
            <i class="contact__icon fa-solid fa-location-dot"></i>
            <h2 class="contact__subtitle">Colombia</h2>
          </div>
          <div class="contact__data">
            <i class="contact__icon fa-solid fa-phone"></i>
            <h2 class="contact__subtitle">+57 301 149 3468</h2>
          </div>
          <div class="contact__data">
            <i class="contact__icon fa-solid fa-envelope"></i>
            <h2 class="contact__subtitle">gerlin@gegova.com.co</h2>
          </div>
          <div class="contact__data">
            <i class="contact__icon fa-solid fa-circle-check"></i>
            <h2 class="contact__subtitle">Analista SOC & TI</h2>
          </div>
        </section>
        <section class="contact__form-box">
          <div class="contact__map" id="load-iframe-map">
            <span class="loader"></span>
          </div>
          <header class="contact__form-header">
            <h3 class="form-header__subtitle">
             Hablemos de  <span class="subtitle__color">oportunidades</span>
            </h3>
          </header>
          <form action="{% url 'detail' %}" method="post" class="contact__form">
            <div class="form__container">
              <section class="form__lef">
                <div class="form__group">
                  <input
                    type="text"
                    class="form__input"
                    name="fullname"
                    placeholder="Nombre"
                  />
                  <label for="name" class="form__label">
                    Nombre
                  </label>
                </div>
                <div class="form__group">
                  <input
                    type="email"
                    class="form__input"
                    name="email"
                    placeholder="Email"
                  />
                  <label for="mail" class="form__label">
                    Email
                  </label>
                </div>
                {/* <div class="form__group">
                  <input
                    type="text"
                    class="form__input"
                    name="subject"
                    placeholder="Asunto"
                  />
                  <label for="subject" class="form__label">
                    Asunto
                  </label>
                </div> */}
              </section>
              <section class="form__right">
                <div class="form__group form__group--textarea">
                  <textarea
                    class="form__input form__input--textarea"
                    name="messege"
                    placeholder="Mensaje"
                  ></textarea>
                  <label for="message" class="form__label">
                    Mensaje
                  </label>
                </div>
              </section>
            </div>
            <input type="submit" class="form__btn" value="Enviar Mensaje" />
          </form>
        </section>
      </div>
    </section>
  );
};
